import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function Home() {
  const { t } = useTranslation();

  const intro1 = t("welcome").split("");
  const intro2 = t("welcome2").split("");

  const waveVariants = {
    hidden: { y: 60, scaleY: 0.2, opacity: 0 },
    visible: (i) => ({
      y: 0,
      scaleY: 1,
      opacity: 1,
      transition: {
        delay: i * 0.08,
        duration: 0.6,
        type: "spring",
        stiffness: 300,
        damping: 20,
      },
    }),
  };

  return (
    <section id="home" className="home-section section">
      <div className="intro-container">
        <h1
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <span style={{ display: "flex" }}>
            {intro1.map((char, i) => (
              <motion.span
                key={i}
                custom={i}
                variants={waveVariants}
                initial="hidden"
                animate="visible"
                style={{
                  display: "inline-block",
                  fontSize: "3rem",
                  fontWeight: "bold",
                  lineHeight: 1,
                }}
              >
                {char === " " ? "\u00A0" : char}
              </motion.span>
            ))}
          </span>
          <span style={{ display: "flex" }}>
            {intro2.map((char, i) => (
              <motion.span
                key={i}
                custom={i}
                variants={waveVariants}
                initial="hidden"
                animate="visible"
                style={{
                  display: "inline-block",
                  fontSize: "3rem",
                  fontWeight: "bold",
                  lineHeight: 1,
                }}
              >
                {char === " " ? "\u00A0" : char}
              </motion.span>
            ))}
          </span>
        </h1>
        <motion.p
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{
            delay: intro1.length * 0.08 + intro2.length * 0.08 + 0.3,
            duration: 0.7,
            type: "spring",
          }}
          style={{ fontSize: "1.5rem", color: "#fff" }}
        >
          {t("teaser")}
        </motion.p>
      </div>
    </section>
  );
}
